import Button from '@mui/material/Button';
import PrintIcon from '@mui/icons-material/Print';
import React, { useCallback, useRef } from 'react';
import { Row } from 'components/Grid';
import PrintHandler from 'components/PrintHandler';
import CommunityWaiver from 'containers/CommunityWaiver';
import { useApolloClient, useQuery } from '@apollo/client';
import { useRouter } from 'found';
import CommunityPage from './Page';
import { GET_PROFILE_INFO } from '../../schema/apolloQueries/commonQueries';
import { GET_FETCH_SPONSOR_DETAILS_INFO } from '../../schema/apolloQueries/communityDetailsQueries';

const styles = {
  heading: {
    marginBottom: 0,
  },
  buttonWrapper: {
    justifyContent: 'flex-end',
  },
  container: {
    fontSize: 12,
    padding: 10,
    textAlign: 'justify',
    marginBottom: 20,
  },
};

const CommunityWaiverPage = () => {
  // const { community } = viewer;
  const {
    match: { params },
  } = useRouter();
  const printRef = useRef(null);

  const { data } = useQuery(GET_FETCH_SPONSOR_DETAILS_INFO, {
    variables: {
      slug: encodeURIComponent(params?.communitySlug),
    },
  });
  const client = useApolloClient();

  const profileData = client.readQuery({
    query: GET_PROFILE_INFO,
  });

  return (
    <CommunityPage
      community={data?.fetchSponsorDetails}
      title='Waiver'
      viewer={profileData?.getProfile}
    >
      <CommunityWaiver
        community={data?.fetchSponsorDetails}
        ref={printRef}
        style={styles.container}
      />
      <Row style={styles.buttonWrapper}>
        <PrintHandler
          content={useCallback(() => printRef.current, [printRef])}
          trigger={useCallback(
            () => (
              <Button icon={<PrintIcon />} primary>
                Print
              </Button>
            ),
            [],
          )}
        />
      </Row>
    </CommunityPage>
  );
};

export default CommunityWaiverPage;
